(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-sale-categories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('premium-sale-categories')) {
  customElements.define('premium-sale-categories', class extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.clock = this.querySelector('[data-countdown]');
      if (!this.clock) return;
      this.expired = this.querySelector('[data-expired]');
      this.parts = Object.fromEntries([...this.querySelectorAll('[data-time]')].map(el => [el.dataset.time, el]));
      const raw = (this.dataset.deadline || '').trim();
      this.deadline = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(raw) ? Date.parse(raw) : NaN;
      const note = this.querySelector('[data-date-error]');
      if (!Number.isFinite(this.deadline)) {
        this.clock.hidden = true;
        if (note) note.hidden = false;
        return;
      }
      if (note) note.hidden = true;
      this.visibility = () => {
        clearInterval(this.interval);
        if (document.hidden) return;
        if (this.tick()) this.interval = setInterval(() => this.tick(), 1000);
      };
      document.addEventListener('visibilitychange', this.visibility);
      this.visibility();
    }
    tick() {
      const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      const values = {days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60};
      Object.entries(values).forEach(([key, value]) => {
        const text = String(value).padStart(2, '0');
        if (this.parts[key].textContent !== text) this.parts[key].textContent = text;
      });
      this.clock.hidden = remaining === 0 && this.dataset.hideExpired === 'true';
      if (this.expired) this.expired.hidden = remaining > 0 || !this.expired.textContent.trim();
      if (remaining === 0) clearInterval(this.interval);
      return remaining > 0;
    }
    stop() {
      clearInterval(this.interval);
      if (this.visibility) document.removeEventListener('visibilitychange', this.visibility);
    }
    disconnectedCallback() { this.stop(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-split-slidshow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('premium-split-slideshow')) {
  customElements.define('premium-split-slideshow', class extends HTMLElement {
    connectedCallback() {
      cancelAnimationFrame(this.frame);
      this.abort?.abort();
      this.abort = new AbortController();
      const on = (el, event, fn) => el.addEventListener(event, fn, {signal:this.abort.signal});
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.index = 0; this.elapsed = 0; this.lastStamp = null;
      this.animations = [];
      this.slides.forEach((slide,i) => {slide.hidden=false;slide.inert=i!==0;slide.setAttribute('aria-hidden',String(i!==0));slide.classList.toggle('is-active',i===0);});
      this.classList.add('is-ready');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.auto !== 'true';
      if (this.slides.length < 2) return;
      this.querySelector('.pss__controls').hidden = false;
      on(this.querySelector('[data-prev]'), 'click', () => this.show(this.index - 1, true));
      on(this.querySelector('[data-next]'), 'click', () => this.show(this.index + 1, true));
      this.dots.forEach((dot, i) => on(dot, 'click', () => this.show(i, true)));
      const pause = this.querySelector('[data-pause]');
      if (pause) on(pause, 'click', () => {this.paused = !this.paused; this.updatePause(); this.schedule();});
      on(document, 'visibilitychange', () => this.schedule());
      on(this.motion, 'change', () => {if(this.motion.matches){this.animations.forEach(a=>a.cancel());} this.updatePause(); this.schedule();});
      on(this, 'shopify:block:select', event => {const i = this.slides.findIndex(s => s.dataset.block === event.detail.blockId); if(i >= 0){this.show(i, false);}});
      on(this, 'touchstart', event => {this.touch = {x:event.changedTouches[0].clientX,y:event.changedTouches[0].clientY};});
      on(this, 'touchend', event => {if(!this.touch)return;const dx=event.changedTouches[0].clientX-this.touch.x;const dy=event.changedTouches[0].clientY-this.touch.y;this.touch=null;if(Math.abs(dx)>60 && Math.abs(dx)>Math.abs(dy)*1.5)this.show(this.index+(dx<0?1:-1),true);});
      this.updatePause(); this.schedule(); this.preloadNext();
    }
    preloadNext(){
      const image=this.slides[(this.index+1)%this.slides.length]?.querySelector('img');
      if(image) image.loading='eager';
    }
    async show(index, manual) {
      const next=(index+this.slides.length)%this.slides.length;
      if(next===this.index){this.elapsed=0;this.schedule();return;}
      cancelAnimationFrame(this.frame);
      const request=(this.request||0)+1;this.request=request;
      const incoming=this.slides[next];
      const image=incoming.querySelector('img');
      if(image)image.loading='eager';
      if(request!==this.request || !this.isConnected)return;
      this.animations.forEach(a=>a.cancel());this.animations=[];
      const outgoing=this.slides[this.index];
      this.index=next;
      this.slides.forEach((slide,i)=>{slide.classList.toggle('is-active',i===next);slide.inert=i!==next;slide.setAttribute('aria-hidden',String(i!==next));});
      const animate=(el,frames,options)=>{if(el)this.animations.push(el.animate(frames,options));};
      if(!this.motion.matches){
        animate(outgoing,[{opacity:1},{opacity:0}],{duration:450,easing:'ease-out'});
        animate(incoming,[{opacity:0},{opacity:1}],{duration:500,easing:'ease-out'});
        animate(outgoing.querySelector('.pss__copy'),[{opacity:1},{opacity:0}],{duration:180,easing:'ease-out'});
        incoming.querySelectorAll('.pss__copy > *').forEach((el,i)=>animate(el,[{opacity:0,transform:'translateY(12px)'},{opacity:1,transform:'translateY(0)'}],{duration:480,delay:100+i*65,easing:'cubic-bezier(.22,.61,.36,1)',fill:'backwards'}));
        if(this.dataset.fit!=='contain')animate(image,[{transform:'scale(1.025)'},{transform:'scale(1)'}],{duration:1400,easing:'ease-out'});
      }
      this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===next)));
      if(manual)this.querySelector('[data-status]').textContent=`Diapozitiv ${next+1} od ${this.slides.length}`;
      this.elapsed=0;this.preloadNext();this.schedule();
    }
    updatePause(){const b=this.querySelector('[data-pause]');if(b){b.textContent=this.paused?'▶':'Ⅱ';b.setAttribute('aria-label',this.paused?'Začni samodejno menjavanje':'Zaustavi samodejno menjavanje');}}
    paintProgress(value){
      this.dots.forEach((dot,i)=>{const fill=dot.querySelector('.pss__fill');if(fill)fill.style.transform=`scaleX(${i===this.index?Math.min(1,Math.max(0,value)):0})`;});
    }
    schedule(){
      cancelAnimationFrame(this.frame);this.lastStamp=null;
      const delay=Number(this.dataset.delay)||6000;
      this.paintProgress(this.dataset.auto==='true'?this.elapsed/delay:1);
      if(!this.isConnected || this.paused || document.hidden || this.slides.length<2)return;
      const tick=stamp=>{
        if(!this.isConnected || this.paused || document.hidden)return;
        if(this.lastStamp!==null)this.elapsed+=stamp-this.lastStamp;
        this.lastStamp=stamp;
        this.paintProgress(this.elapsed/delay);
        if(this.elapsed>=delay){this.show(this.index+1,false);return;}
        this.frame=requestAnimationFrame(tick);
      };
      this.frame=requestAnimationFrame(tick);
    }
    disconnectedCallback(){cancelAnimationFrame(this.frame);this.request=(this.request||0)+1;this.animations?.forEach(a=>a.cancel());this.abort?.abort();}

  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
